import styled from 'styled-components'
import { rem } from 'polished'

export const Container = styled.div`
    padding: ${rem('30px')} 0;
`
